import { forwardRef } from "react";

const Select = forwardRef(({ onChange, onBlur, name, label }, ref) => (
  <>
    <select name={name} ref={ref} onChange={onChange} onBlur={onBlur}>
      <option>I'm interested in this</option>
      <option>I'd like to know your best price for this</option>
      <option>I'd like to test drive this</option>
      <option>I'd like a history report for this vehicle</option>
    </select>
  </>
));

export default Select;
